import { useRecoilValue, useSetRecoilState } from 'recoil';

import CART from '../../../assets/imgs/icon/basket.svg';
import { NumberIndicator } from '../../../components/NumberIndicator';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { isCartModalOpenState } from '../../../Header/atoms';
import { cartQuantityState } from '../../atoms';

export const Icon: React.FC = () => {
	const setIsCartModalOpen = useSetRecoilState(isCartModalOpenState);
	const cartQuantity = useRecoilValue(cartQuantityState);

	return (
		<div onClick={() => setIsCartModalOpen(true)}>
			<IconButton
				url={CART}
				alt={'Cart'}
				width={24}
				height={24}
			></IconButton>

			{cartQuantity > 0 && (
				<NumberIndicator
					offsetX={15}
					offsetY={12.5}
					className="border border-white cart-icon-indicator"
				>
					{cartQuantity}
				</NumberIndicator>
			)}
		</div>
	);
};
